function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "logo/filled");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo/filled",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "filled",
  fill: "#ffffff",
  fillRule: "nonzero"
}, React.createElement("ellipse", {
  id: "Oval",
  cx: 12.7074564,
  cy: 83.2691289,
  rx: 12.7074564,
  ry: 12.6974216
}), React.createElement("ellipse", {
  id: "Oval",
  cx: 31.7669686,
  cy: 50.2511498,
  rx: 15.2496167,
  ry: 15.2395819
}), React.createElement("path", {
  d: "M188.347317,50.6391638 C188.347317,50.6391638 184.470523,47.0701045 177.807387,45.7087108 L177.683624,45.6819512 C177.349129,45.6117073 176.97784,45.5481533 176.61324,45.4912892 C176.395819,45.4578397 176.175052,45.4310801 175.944251,45.4009756 L175.609756,45.3574913 C173.218218,45.0666907 170.797262,45.1218917 168.421463,45.5213937 L168.30439,45.5213937 C163.567944,46.2840418 155.259094,43.0829268 149.201394,38.4970035 C145.247666,35.4865505 139.705087,28.0908711 139.166551,22.8961672 C139.023808,21.5416487 138.77893,20.1998507 138.434007,18.88223 C138.357073,18.5811847 138.273449,18.2801394 138.189826,17.982439 C138.159721,17.8854355 138.136307,17.7817422 138.106202,17.6847387 C137.820501,16.7496052 137.478697,15.8325418 137.082648,14.9385366 L136.985645,14.7244599 C136.858537,14.4434843 136.724739,14.1625087 136.587596,13.884878 C136.477213,13.6641115 136.366829,13.4500348 136.253101,13.2393031 L136.149408,13.0486411 C134.195958,9.43275261 132.058537,7.56961672 132.058537,7.56961672 C127.435883,2.89871752 121.134651,0.27443159 114.563034,0.28323146 C107.991417,0.29203133 101.697236,2.93318342 97.087108,7.61644599 C96.0930351,8.57310935 95.2089462,9.63783063 94.4512892,10.7908014 C91.5664513,14.9069748 90.0221776,19.8131395 90.0292683,24.8395819 C90.0292683,24.9967944 90.0292683,25.154007 90.0292683,25.3112195 C90.0292683,25.4684321 90.0292683,25.5219512 90.0292683,25.6457143 C90.0292683,34.1652962 88.5206969,41.9958188 85.1322648,46.334216 C82.5332404,49.6791638 77.696446,51.324878 72.0334495,52.6294077 L72.0167247,52.6294077 L71.9799303,52.6294077 C70.6271676,52.9546034 69.3154453,53.4314913 68.0696864,54.0510105 C66.0285363,55.0301283 64.1501289,56.3173732 62.5003484,57.8675958 C62.3163763,58.0348432 62.2126829,58.1385366 62.2126829,58.1385366 C56.4533126,63.7111017 54.1773992,71.9733518 56.2708827,79.7090583 C58.3643663,87.4447648 64.4964508,93.4315918 72.2801128,95.3390598 C80.0637749,97.2465278 88.2691008,94.7732336 93.7020209,88.8819512 C94.6966397,87.8643313 95.5596833,86.7259678 96.2709408,85.4935192 C98.4103144,82.0285961 99.5408944,78.0356562 99.5356098,73.9634843 C99.5349658,72.7690082 99.4376446,71.5765436 99.2445993,70.39777 C99.2445993,70.3777003 99.2445993,70.3576307 99.2445993,70.337561 C98.4886411,64.6177003 99.6393031,60.6372125 101.555958,57.8776307 C104.141603,54.1379791 109.356376,49.6925436 116.303833,49.7092683 C122.134077,49.729338 127.857282,52.4052962 132.653937,56.1850871 C141.601672,63.2362369 145.424948,70.6051568 148.846829,79.5997213 C148.890314,79.7134495 148.937143,79.8204878 148.980627,79.934216 C149.070941,80.1616725 149.161254,80.3891289 149.258258,80.6032056 L149.285017,80.6600697 C150.032056,82.3805493 150.967675,84.0128343 152.074704,85.5269686 L152.074704,85.5470383 L152.385784,85.9618118 C153.054069,86.8624919 153.792239,87.7091504 154.593449,88.4939373 C161.254219,95.1640205 171.060916,97.5971341 180.067067,94.8141288 C189.073217,92.0311234 195.797664,84.4896935 197.534312,75.2247104 C199.270961,65.9597273 195.7342,56.4949146 188.347317,50.6391638 Z",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "96px",
    viewBox: "0 0 198 96",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/mid.9201ddc0.svg";
export { SvgComponent as ReactComponent };